/* Oil PDP ritual tab/panel core (ao-vnext-pdp.js), namespaced to the Homepage slot. */
(() => {
  'use strict';
  if (window.AoHomeSlotRitual) { window.AoHomeSlotRitual.scan(); return; }
  const instances = new Map();
  const init = (root) => {
    if (instances.has(root)) return;
    const ac = new AbortController();
    const listen = (el, type, fn) => el.addEventListener(type, fn, { signal: ac.signal });
    const tabs = [...root.querySelectorAll('[data-home-slot-ritual-tab]')];
    const panels = [...root.querySelectorAll('[data-home-slot-ritual-panel]')];
    const activate = (key, focus = false) => {
      const activeTab = tabs.find((tab) => tab.dataset.homeSlotRitualTab === key);
      const activePanel = panels.find((panel) => panel.dataset.homeSlotRitualPanel === key);
      if (!activeTab || !activePanel) return;
      tabs.forEach((tab) => {
        const active = tab === activeTab;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
      if (focus) activeTab.focus();
    };
    tabs.forEach((tab, index) => {
      listen(tab, 'click', () => activate(tab.dataset.homeSlotRitualTab));
      listen(tab, 'keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else next = (index + 1) % tabs.length;
        activate(tabs[next].dataset.homeSlotRitualTab, true);
      });
    });
    const initial = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    if (initial) activate(initial.dataset.homeSlotRitualTab);
    instances.set(root, { destroy: () => ac.abort(), activate });
  };
  const scan = () => document.querySelectorAll('[data-home-slot-ritual]').forEach(init);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((instance, root) => {
      if (event.target.contains(root)) { instance.destroy(); instances.delete(root); }
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.shopify-section');
    const root = section?.querySelector('[data-home-slot-ritual]');
    if (root && event.detail?.blockId) instances.get(root)?.activate(event.detail.blockId);
  });
  window.AoHomeSlotRitual = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
